import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ShopService } from '@app/services/shops/shop.service';
import { DynamicRule, RuleEntity } from '@pdqdev/pdq-shared/dist/entities/Rules';
import { CheckoutUpsellExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';

@Component({
  selector: 'checkout-upsell-display-conditions',
  templateUrl: './checkout-upsell-display-conditions.component.html',
  styleUrls: ['./checkout-upsell-display-conditions.component.scss'],
  standalone: false,
})
export class CheckoutUpsellDisplayConditionsComponent {
  @Input() formGroup: UntypedFormGroup;
  @Input() restrictionsRules: DynamicRule[];
  @Input() entities: RuleEntity[];
  @Input() shopCurrencySymbol: string;

  readonly formArrayFieldName = 'restrictionsRules';
  readonly ConditionsUnmetBehavior = CheckoutUpsellExtension.ConditionsUnmetBehavior;

  constructor(private shopService: ShopService) {}

  get isAutoRemoveAvailable(): boolean {
    return !!this.shopService.metadata?.enableUpsellAutoRemoveOnConditionsNotMet;
  }
}
